/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'home': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M417.136 139.173h-218.02a59.9 59.9 0 00-59.943 59.9v218.022a59.9 59.9 0 0059.9 59.942h218.022a59.777 59.777 0 0059.942-59.942v-217.98a59.86 59.86 0 00-59.9-59.942zm450.168 17.564a59.86 59.86 0 00-42.42-17.564H606.906a59.86 59.86 0 00-59.942 59.942v218.021a59.942 59.942 0 0059.942 59.901h217.98a59.86 59.86 0 0059.942-59.942V199.157c0-15.908-6.297-31.152-17.523-42.378zm-450.21 390.226H199.158a59.942 59.942 0 00-59.984 59.9v218.022a59.9 59.9 0 0059.9 59.942h218.022a59.86 59.86 0 0059.942-59.942v-217.98a59.86 59.86 0 00-59.942-59.942zm407.832 0H606.864a59.86 59.86 0 00-59.943 59.9v218.022a59.942 59.942 0 0059.943 59.942h218.02a59.9 59.9 0 0059.943-59.942v-217.98a59.942 59.942 0 00-59.942-59.942z" _fill="#2c2c2c"/>'
  }
})
